import { register } from "@rill/loader";

// A short ttl on purpose: the state of the domain also changes without the coach (the hourly
// recheck, a pause after bounces), so there is no point to bust a long cache from
register(
  {
    name: "sendingSettings",
    ttl: "2 seconds",
  },
  async ({ api }) => {
    const res = await api("automation-sending-settings");
    // The account does not have Email Automations (or the user cannot see them)
    if (!res.ok) return null;
    return res.json();
  }
);
